import Group from './Group';
import People from './People';
import SignIn from './SignIn';
import SignUp from './SignUp';
import VerifyReset from './VerifyReset';
import ForgottenPassword from './ForgottenPassword';

export const GroupPage = Group;
export const PeoplePage = People;
export const SignInPage = SignIn;
export const SignUpPage = SignUp;
export const VerifyResetPage = VerifyReset;
export const ForgottenPasswordPage = ForgottenPassword;
